import { useEffect } from 'react';

import FinList from '../FinList';

import { Helmet } from "react-helmet";

const FinListTW = () => {
	useEffect(() => {
		let pageLastViewed = localStorage.getItem("page-last-viewed");
		pageLastViewed = JSON.parse(pageLastViewed);
		pageLastViewed.finlist.tw = new Date().getTime();
		localStorage.setItem("page-last-viewed", JSON.stringify(pageLastViewed));
	}, [ ]);

	return (
		<>
			<Helmet>
				<title>FinList (TW) - Finetic App</title>
			</Helmet>
			<FinList exchange="TW" />
		</>
	);
};

export default FinListTW;
